import { History, X } from "lucide-react";

import { AssistantCreditsIndicator } from "src/components/AssistantChat/AssistantCreditsIndicator";
import { StoreSwitcher } from "src/components/Sidebar/StoreSwitcher";
import { Badge } from "src/components/ui/badge";
import { Button } from "src/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "src/components/ui/tooltip";

export const AssistantHeader = ({
  currentChatTitle,
  isMobile,
  creditStatus,
  sourcesOfTruth,
  onOpenHistory,
  onClose,
}) => (
  <div className="border-border/70 flex items-center gap-3 border-b px-4 py-3">
    <div className="flex min-w-0 flex-1 items-center gap-3">
      <div className="w-[min(16rem,calc(100vw-11rem))] min-w-0 sm:w-64">
        <StoreSwitcher
          dropdownPosition="bottom-left"
          className="bg-card/50 hover:bg-muted/70 data-[state=open]:bg-muted/70 data-[state=open]:text-foreground"
        />
      </div>

      <span
        className="border-border/80 bg-card/90 text-foreground/90 hidden max-w-[20rem] truncate rounded-md border px-2.5 py-1 text-xs font-medium shadow-sm sm:inline-block lg:max-w-[28rem]"
        title={currentChatTitle}
      >
        {currentChatTitle}
      </span>
    </div>

    <div className="ml-auto flex shrink-0 items-center gap-2">
      {isMobile ? (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="size-8"
          onClick={onOpenHistory}
          aria-label="Open chat history"
        >
          <History className="size-4" />
        </Button>
      ) : null}

      <AssistantCreditsIndicator creditStatus={creditStatus} />

      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            variant="outline"
            className="hidden cursor-default rounded-md sm:inline-flex"
          >
            {sourcesOfTruth.length} source
            {sourcesOfTruth.length === 1 ? "" : "s"} of truth
          </Badge>
        </TooltipTrigger>
        <TooltipContent side="bottom" align="end" className="rounded-xl p-3">
          <div className="space-y-2">
            <div className="text-sm font-medium">Sources of truth</div>
            <div className="space-y-1">
              {sourcesOfTruth.map((source) => (
                <div key={source.id} className="text-muted-foreground text-xs">
                  {source.label}
                </div>
              ))}
            </div>
          </div>
        </TooltipContent>
      </Tooltip>

      {!isMobile ? (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="size-8"
          onClick={onClose}
          aria-label="Close assistant"
        >
          <X className="size-4" />
        </Button>
      ) : null}
    </div>
  </div>
);
